import { render, staticRenderFns } from "./yunying.vue?vue&type=template&id=35032791&scoped=true"
import script from "./yunying.vue?vue&type=script&lang=js"
export * from "./yunying.vue?vue&type=script&lang=js"
import style0 from "./yunying.vue?vue&type=style&index=0&id=35032791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35032791",
  null
  
)

export default component.exports